import { render, staticRenderFns } from "./DeletePopup.vue?vue&type=template&id=d9e38072&"
import script from "./DeletePopup.vue?vue&type=script&lang=js&"
export * from "./DeletePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports